import { gql } from "@apollo/client";

export default gql`
  fragment TimeAndStatus on Race {
    mtp
    postTime
    status {
      code
    }
    raceDate
  }
`;
